import { safeJsonParse } from "@swiggy-private/js-utils";
import Blaze from "@swiggy-private/blaze.js";
import { isApp } from "@swiggy-private/portal-dineout-context";
import { getSwiggyHeaders } from "./nativeBridgeHelper";
import { STORAGE_KEYS } from "../constants";

const eventType = "portal_dineout";

export const filterHeaders = (swiggyHeaders: Record<string, string | undefined>) => {
    return {
        deviceId: swiggyHeaders?.deviceId || "--",
        sid: swiggyHeaders?.sid || "--",
        userId: swiggyHeaders?.userId || "--",
        platform: swiggyHeaders?.platform || "--",
        appVersionCode: swiggyHeaders?.["version-code"] || "--",
        xChannel: swiggyHeaders?.["x-channel"] || "--",
    };
};

export const getRestaurantId = () => {
    const storedConfig = sessionStorage?.getItem?.(STORAGE_KEYS.TABLE_CONFIG);
    const parsedConfig = safeJsonParse<{ restaurantId?: string }>(storedConfig || "{}", {});
    return parsedConfig?.restaurantId || "--";
};

export const sendCustomNREvViaBlaze = (
    type: string,
    body: Record<string, string | number | boolean>,
    headers: Record<string, string | undefined> | void,
) => {
    const swgyHeaders = headers ? filterHeaders(headers) : {};
    Blaze.recordCustomEvent({
        eventType: eventType,
        isApp: `${isApp()}`,
        type,
        referrer: window.location.href,
        restaurantId: getRestaurantId(),
        ...body,
        ...swgyHeaders,
    });
};

export const sendCustomNREvWithHeaders = async (type: string, body: Record<string, string | number>) => {
    const swgyHeaders = await getSwiggyHeaders();
    sendCustomNREvViaBlaze(type, body, swgyHeaders);
};
